import { Field, Formik } from "formik";
import { isEmpty, get } from "lodash";
import React, { useState } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../abstracts";
import {
  DatePicker,
  FieldDropSide,
  CsplTable as Table,
  MultiSelectDropdown,
  Link,
  SliderPanel,
  CensusVestingCard,
  LoaderWrapper,
} from "../../../../components";
import {
  manageCensusFormNames,
  usDateFormat,
  formFields,
  toMultiSelectValue,
  formatDateForApiRequest,
} from "../../../../utils";
import {
  setManageCensusPageLevelData,
  manageCensusStore,
} from "../../../../contexts";
import { useContext } from "react";
import { getEmployeeVestingDetails } from "../../../../services";

const Vesting = (props) => {
  const { state, dispatch } = useContext(manageCensusStore);
  const { planId, censusId } = useRouterParams();
  const [toggle, setToggle] = useState(false);
  const [sources, setSources] = useState([]);
  const [currentPlan, setCurrentPlan] = useState({});
  const [vestingDetails, setVestingDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useDeepEffect(() => {
    setIsLoading(true);
    getEmployeeVestingDetails({
      planId: planId,
      employeeId: censusId,
    })
      .then((response) => {
        setIsLoading(false);
        setVestingDetails(response);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [toggle]);

  //   const formName = manageCensusFormNames.CONTRIBUTIONS_FILTER;
  //   const fields = formFields[formName];

  var ComputationPeriodsGroupedByOfSources = vestingDetails.reduce(
    (group, product) => {
      const { sourceId } = product;
      group[sourceId] = group[sourceId] ?? [];
      group[sourceId].push(product);
      return group;
    },
    {}
  );
  //var latestOfEachSource = ComputationPeriodsGroupedByOfSources.map((item)=> item[key]);

  var sourceWiseComputationalPeriods = Object.values(
    ComputationPeriodsGroupedByOfSources
  );
  //print values1 array

  var currentComputationPeriodsOfEachsource = sourceWiseComputationalPeriods.map(
    (item, index) => {
      return item[item.length - 1];
    }
  );

  const onFormSubmit = (values) => {
    // dispatch(
    //   setManageCensusPageLevelData({
    //     formName: formName,
    //     fieldData: values,
    //   })
    // );
  };
  return (
    <>
      <LoaderWrapper isLoading={isLoading}>
        <Formik initialValues={{}} onSubmit={onFormSubmit} enableReinitialize>
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            setFieldError,
            values,
            ...rest
          }) => {
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
              >
                <div
                  style={{
                    marginTop: "30px",
                    maxHeight: "58vh",
                    overflowY: "scroll",
                  }}
                >
                  {vestingDetails.length === 0 ? (
                    <p>No records found</p>
                  ) : (
                    currentComputationPeriodsOfEachsource.map((item, index) => {
                      return (
                        <div style={{ marginBottom: "25px" }}>
                          <CensusVestingCard
                            data={item}
                            toggle={toggle}
                            setToggle={setToggle}
                            setFieldError={setFieldError}
                            BISType={item?.bisType}
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default Vesting;
